import { useEffect, useState } from 'react'

import { getLocaleFromPath } from '@nx/smartling'
import { getTranslate } from '@nx/translations'
import { useUserInteraction } from '@nx/utils/google-tag-manager'

import {
  FireStyledButtonNavItem,
  FireStyledLinkNavItem,
  StyledChevronDownIcon,
  StyledLanguageNav,
} from '../../FireHeader.styles'
import translate from './LanguageNav.translate.json'

const { text } = getTranslate(translate)

export function LanguageNav({
  toggleVisible,
  show,
  uniqueName,
  links,
  $isMobileOnly,
}: LanguageNavProps) {
  const [activePath, setActivePath] = useState<string>()
  const { recordInteraction } = useUserInteraction()

  useEffect(() => {
    setActivePath(document.location.pathname)
  }, [])

  return (
    <>
      <FireStyledButtonNavItem
        variant="ghost"
        onClick={() => toggleVisible((prevValue) => !prevValue)}
        aria-haspopup="true"
        aria-controls={uniqueName}
        aria-expanded={show}
        data-testid={`${uniqueName}-control`}
        $isExpanded={show}
        $isMobileOnly={$isMobileOnly}
      >
        {text('title')}
        <StyledChevronDownIcon />
      </FireStyledButtonNavItem>

      <StyledLanguageNav
        id={uniqueName}
        aria-label={text('title')}
        data-testid={uniqueName}
        aria-hidden={!show}
        $visible={show}
      >
        {links.map(({ text, href }) => (
          <FireStyledLinkNavItem
            key={`${uniqueName}-${text}-${$isMobileOnly}`}
            href={href}
            forceAnchor
            $isActive={activePath === href}
            $isMobileOnly={$isMobileOnly}
            onClick={() => {
              recordInteraction({
                action: 'language.select',
                category: 'Languages - Navigation Dropdown',
                label: getLocaleFromPath(href),
              })
            }}
          >
            {text}
          </FireStyledLinkNavItem>
        ))}
      </StyledLanguageNav>
    </>
  )
}

interface LanguageNavProps {
  toggleVisible: React.Dispatch<React.SetStateAction<boolean>>
  show: boolean
  links: {
    text: string
    href: string
  }[]
  uniqueName: string
  $isMobileOnly?: boolean
}
